<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow" ref="menuResize">
			<div class="tableMes">
				<div class="table newTable">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree" style="height: 100%;">
						<!-- <el-tab-pane label="设备类型" name="first">
							<tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane> -->
						<el-tab-pane :label="$t('label_161')" name="second" width="100%">
							<tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
<!--              <tree :dataTree="treeData2" :treeType="1" :pink="1" @getDeviceMes="getDeviceMes"-->
<!--                    ref="treeDisplay2"></tree>-->
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
			<!-- <div class="dragBox" ref="dragResize"></div> -->
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<!-- <img style="width:100%;height:100%;" src="../../../static/img/buttonRight.png"> -->
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'0':'60px 0px 0px 350px '}" ref="operaResize">
			<div class="tableMes treeMes">
				<div class="table" style="padding: 0" v-if="!eqDetail">
					<div class="treeMes" v-if="getTreeMes=='1'" style="position: relative">
						<p class="title"><span class="spot">{{'<'+(deviceDetailMes.name==undefined?$t('label_272'):deviceDetailMes.name)+">"}}</span>
							{{$t('label_522')}}</p>
						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div style="display: flex;align-items: center">
									<p style="margin-right: 20px;font-weight: bold">{{$t('label_524')}}</p>
									<el-radio v-model="radio" label="1" @change="selLables">{{$t('label_542')}}</el-radio>
									<el-radio v-model="radio" label="2" @change="selLable">{{$t('label_537')}}</el-radio>
									<div v-if="timeChange==1">
										<!-- <el-date-picker v-model="Readytime" type="monthrange" align="right" unlink-panels :range-separator="$t('label_264')"
                     start-placeholder="开始月份" end-placeholder="结束月份" style='width:355px;'>
                    </el-date-picker> -->
										<el-date-picker
                      v-model="Readytime[0]" type="month" :clearable="false" align="right" style='width:120px;'>
										</el-date-picker>
										<span style="margin: 0 5px;">{{$t('label_264')}}</span>
										<el-date-picker
                      v-model="Readytime[1]" type="month" :clearable="false" align="right" style='width:120px;'>
										</el-date-picker>
									</div>
									<div v-else>
										<!-- <el-date-picker v-model="value1" type="datetimerange" unlink-panels format="yyyy-MM-dd HH:00" value-format="yyyy-MM-dd HH:mm"
                     :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')" style='width:355px;'>
                    </el-date-picker> -->
										<el-date-picker
                      v-model="value1[0]" type="datetime" :clearable="false" align="right" style='width:200px;'
                      format="yyyy-MM-dd HH:00" value-format="yyyy-MM-dd HH:mm">
										</el-date-picker>
										<span style="margin: 0 5px;">{{$t('label_264')}}</span>
										<el-date-picker
                      v-model="value1[1]" type="datetime" :clearable="false" align="right" style='width:200px;'
                      format="yyyy-MM-dd HH:00" value-format="yyyy-MM-dd HH:mm" >
										</el-date-picker>
									</div>
                  <div class="selectChoose">
                    <div class="selectTexts" style="width: 70px">
                      <p>{{$t('label_501')}}</p>
                    </div>
                    <el-select v-model="sortName">
<!--                      <el-option label="稼动率" value="activation">-->
<!--                      </el-option>-->
                      <el-option :label="$t('label_194')" value="code">
                      </el-option>
                    </el-select>
                  </div>
                  <div style="display: flex;align-items:center">
                    <el-radio v-model="sort" label="ASC">{{$t('label_526')}}</el-radio>
                    <el-radio v-model="sort" label="DESC">{{$t('label_528')}}</el-radio>
                  </div>
								</div>
<!--                <div class="selectChoose">-->
<!--                  <div class="selectText">-->
<!--                    <p>设备编号</p>-->
<!--                  </div>-->
<!--                  <div class="select" style="width:350px">-->
<!--                    <el-input v-model="deviceCode" clearable></el-input>-->
<!--                  </div>-->
<!--                </div>-->
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box dashBox" style="height: calc(100% - 218px); overflow-x: hidden;overflow-y: scroll;">
							<div style="'height: calc(100% - 700px);width:100%;display: flex;flex-wrap: wrap;'">
								<div class="box_all_style" v-for="(item,index) in showList" :key="index">
									<div class="font_one" @click="detailShow(item)">
										<p v-if="item.companyNumber != null">{{item.code}}{{'<'+ item.companyNumber +'>'}}</p>
                    <p v-else>{{item.code}}</p>
<!--                    <p>{{item.code}}</p>-->
										<p>{{item.code}} {{item.name}}</p>
									</div>
									<div class="Echarts">
										<gaugeChart :chartsId="item.id" :data='data_list_new[item.id].activation' style="width: 250px;height: 165px;"></gaugeChart>
									</div>
									<div class="box_down">
										<div style="display: flex;align-items: center;height: 30px;margin-top: 10px">
											<div :class="data_list_new[item.id].maxActivation==0?'box_conent_ones':'box_conent_one'"></div>
											<div class="box_conent_m" style="font-weight: 700">MAX({{$t('label_659')}})</div>
											<div class="box_conent_number">{{(data_list_new[item.id].maxActivation>100?100:data_list_new[item.id].maxActivation)}}%</div>
										</div>
										<div style="display: flex;align-items: center;height: 30px;margin-top: 10px">
											<div :class="data_list_new[item.id].minActivation==0?'box_conent_ones':'box_conent_one'"></div>
											<div class="box_conent_m" style="font-weight: bold">MIN({{$t('label_661')}})</div>
											<div class="box_conent_number">{{(data_list_new[item.id].minActivation>100?100:data_list_new[item.id].minActivation)}}%</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div >
					<div style="position: absolute;bottom: 30px;right: 5%">
						<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
						 @parentMethod="searchPage"></Page>
					</div>
				</div>
				<div class="table" v-else>
					<eqDetail :eqId="eqId" @detailClose="detailClose"></eqDetail>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/pageNew2";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/equTree";
  // import tree from "@/components/list/tree/tree";
	import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
	import file from "@/assets/js/file/file.js";
	import popMesBox from "@/components/list/popover/pop";
	import tabularStatistics from "@/components/list/tabPane/tabularStatistics";
	import graphicStatistics from "@/components/list/tabPane/graphicStatistics";
	import gaugeChart from "@/components/list/chart/gaugeChart";
	import eqDetail from "@/components/list/equipmentDetails/eqDetail";
	import $ from 'jquery'

	export default {
		name: 'equipmentDesign',
		components: {
			Page,
			tree,
			popMesBox,
			tabularStatistics,
			graphicStatistics,
			gaugeChart,
			eqDetail
		},
		data() {
			return {
				eqDetail: false,
				eqId: '',
				timer: null,
				value1: [], // 日时间
				value2: '',
				radio: '1',
				activeNameSpot: 'inspectionEquipment',
				dateValue: [],
				dateValues: [],
				pageNum: 1,
				pageSize: 50,
				pageCount: 0,
				Readytime: '', // 时间月
				code: '',

				getTreeMes: '1',
				img: '',
				checked: false,
				dialogImg: false,
				dialogVideo: false,
				dialogSpotRemark: false,
				deviceDetailMes: {
					type: 2,
					id: '0',
				},
				dialogSpotResult: false,
				MenuRoleList: [],
				newType: {
					id: '',
					remark: ''
				},
				tableDataTree: [],
				tableDataTreeInfo: [],
				tableDataInfo: [],
				typeName: '',
				deptName: '',
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				checkList: [],
				weekendMesOptions: [this.$t('label_716'), this.$t('label_719'), this.$t('label_721'), this.$t('label_723'), this.$t('label_725'), this.$t('label_728'), this.$t('label_730')],
				monthDOptions: [],
				monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
				tableDataTreeTime: [],
				activeNameTree: 'second',
				status: '',
				timeChange: '1', // 用来判断日期格式
				linshilist: [],
        showList: [],
				total: 0, // 总页数
				newList: [], // 月份传递的list
				beginTime: '',
				endTime: '',
				dyTime: '',
				ydyTime: '', // 月当前时间
				typeNext: true, // 是否包含当前时间
				date_value: '',
				date_values: '',
				date_valuess: '',
				date_valuessss: '',
				data_list_new: {},
				width: '340px',
				qrCodeShow: false,
				ceshilist: [{
					id: 0,
					name1: '测试1',
					name2: '测试2'
				}, {
					id: 1,
					name1: '测试3',
					name2: '测试4'
				}],
        // deviceCode: '',
        sortName: 'code',
        sort: 'ASC',


			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
    updated() {
		  this.$nextTick(() => {
        this.$refs.pageModel.setCurrent(this.pageNum);
      })
    },
    methods: {
			showBtn() {

				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
					//this.$refs.menuResize.style.width = "0px";
					//this.$refs.operaResize.style.width = document.documentElement.clientWidth +"px";
				} else {
					this.width = "340px";
					//this.$refs.menuResize.style.width = "340px";
					//this.$refs.operaResize.style.width = document.documentElement.clientWidth -340 +"px";
				}
			},
			dropSize() {
				let that = this,
					menuWidth = 200,
					operaHeight = 200;
				this.$refs.dragResize.onmousedown = function() {
					document.onmousemove = function(e) {
						let clientX = e.clientX;
						// 最大宽度
						if (clientX >= 800) {
							clientX = 800;
						}
						// 最小宽度
						if (clientX <= 495) {
							clientX = 495;
							// TODO 这里减的是最左侧tab的宽度
							menuWidth = clientX - 30;
						}
						that.$refs.menuResize.style.width = clientX - 275 + "px";
						that.$refs.operaResize.style.width = window.screen.width - clientX + 35 + "px";
						document.onmouseup = function() {
							document.onmousemove = null;
							document.onmouseup = null;
							that.releaseCapture && that.releaseCapture()
						}
					}
				}
			},
			//显示设备详细
			detailShow: function(eq) {
				this.eqId = eq.id;
				this.eqDetail = true;
				console.log("show",this.deviceDetailMes.type)
			},
			//关闭设备详细
			detailClose: function() {
        console.log("close",this.deviceDetailMes.type)
				this.eqDetail = false;
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				// console.log(param)
				this.searchPage(param);
			},
			sizeChangeInputHanlder(val) {
				this.pageSize = val
				this.search()
			},
			// 当前页码改变
			handleCurrentChange(val) {
				this.pageNum = val
				this.search()
			},
			getDeviceMes(data) {
			  // this.deviceCode = '';
				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes = data
					this.deviceDetailMes.type = 2
				} else {
					this.deviceDetailMes = data;
				}
				this.search();
			},
			myEcharts(bf, id) {
				// console.log('获取到的百分比', bf)
				// console.log('获取到的id',id)
				let newbf = bf / 100
				let myChart = this.$echarts.init(document.getElementById(id));
				//配置图表
				let option = {
					//提示框组件。开发实际中去掉了指针，提示框可以不用设置。
					tooltip: {
						formatter: "{a} <br/>{b} : {c}%"
					},
					//工具栏。本次好像也没用到，刷新，下载，我觉得还是挺实用的，具体开需求！
					//下面属性才是仪表盘的核心！！反正我是这么认为的！！！
					series: [{
						//类型
						type: 'gauge',
						//半径
						radius: 100,
						//起始角度。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
						startAngle: 180,
						//结束角度。
						endAngle: 0,
						center: ['50%', '40%'],
						//仪表盘轴线相关配置。
						axisLine: {
							show: true,
							// 属性lineStyle控制线条样式
							lineStyle: {
								width: 30,
								color: [
									[newbf, '#3FB393'],
									[1, '#EEEEEE']
								] // 需要将百分比转换成小数
							}
						},
						//分隔线样式。
						splitLine: {
							show: false,
						},
						//刻度样式。
						axisTick: {
							show: false,
						},
						//刻度标签。
						axisLabel: {
							color: '#c8c7c7',
							fontSize: 20,
							length: 15,
							formatter: function(value) {
								let texts = [];
								if (value == 0) { // y轴刻度
									texts.push('0');
								} else if (value == 100) {
									texts.push('100');
								}
								return texts;
							},
						},
						//仪表盘指针。
						pointer: {
							show: false,
							//指针长度
							length: '90%',
							width: 0, // 不显示仪表盘的指针
						},
						//仪表盘标题。
						title: {
							show: true,
							offsetCenter: ['20px', '40px'], // x, y，单位px
							textStyle: {
								color: '#000',
								fontSize: 30
							}
						},
						//仪表盘详情，用于显示数据。
						detail: {
							show: true,
							offsetCenter: [0, '-30%'],
							formatter: '{value}%',
							textStyle: {
								fontSize: 30,
								color: '#000',
							}
						},
						data: [{
							value: bf, //  正常回显百分比
						}],
					}]
				};
				myChart.setOption(option);
				/*
				//设置定时，加载随机数据，可以直观显示  测试用
				let random=(Math.random() * 100).toFixed(2);
				let color=[['0.5', '#3FB393'], [1, '#EEEEEE']];
				option.series[0].axisLine.lineStyle.color=color;
				myChart.setOption(option, true);
				myChart.setOption(option);
				 */
			},
			linshiLists() {
				// let	that=this;
				/* this.linshilist.forEach(item=>{     //  渲染echarts
        setTimeout(function(){
      that.myEcharts(that.data_list_new[item.id].activation,item.id)
    },100)
      }) */

			},
			// 点击单选框 月  1
			selLables(val) {
				// console.log('月',val)
				this.timeChange = val
			},
			// 点击单选框  日 2
			selLable(val) {
				// console.log('日', val)
				this.timeChange = val
			},
			//  点击查询
			searchlist() {
				if (this.timeChange == 1) { // timeChange==1 月   2 日
					this.beginTime = this.Readytime[0] // 开始时间
					this.endTime = this.Readytime[1] //  结束时间
					// console.log('当前时间',this.dyTime[0])
					let date = new Date(this.Readytime[0]); //  时间格式准换
					let dates = new Date(this.Readytime[1]); //  时间格式准换
					this.date_value = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() +
						1)
					this.date_values = dates.getFullYear() + '-' + (dates.getMonth() + 1 < 10 ? '0' + (dates.getMonth() + 1) : dates.getMonth() +
						1)
					// console.log('选择开始时间',this.date_value)
					// console.log('选择结束时间',this.date_values)
					let _PlanEndTime = new Date(this.date_value) // 时间比较前 格式准换    开始时间
					let _PlanStartTime = new Date(this.date_values) // 时间比较前 格式准换    结束时间
					let _PlanNowTime = new Date(this.dyTime[0]) // 时间比较前 格式准换    当前时间
					date = { // 用来判断时间是否在某个区间内
						isDuringDate: function(beginDateStr, endDateStr) {
							let curDate = new Date(),
								beginDate = new Date(beginDateStr),
								endDate = new Date(endDateStr);
							if (curDate >= beginDate && curDate <= endDate) {
								return true;
							}
							return false;
						}
					}
					if (_PlanNowTime.getTime() == _PlanEndTime.getTime() || _PlanNowTime.getTime() == _PlanStartTime.getTime()) { // 判断 当前时间是否等于开始或结束时间
						this.typeNext = true
						// console.log('当前时间等于开始或结束时间')
					} else if (date.isDuringDate(this.date_value, this.date_values) == true) {
						this.typeNext = true
						// console.log('当前时间在开始结束时间段内')
					} else {
						// console.log('当前时间不等于开始时间不等于结束时间不包含区间内')
						this.typeNext = false
					}
					file.KPIselectList({
						list: this.newList,
						beginTime: this.date_value,
						endTime: this.date_values,
						next: this.typeNext
					}).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.data_list_new = data.data
              this.showList = this.linshilist;
              // console.log(this.data_list_new);
							// this.linshiLists();
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					this.beginTime = this.value1[0] // 开始时间
					this.endTime = this.value1[1] //  结束时间
					// console.log('当前时间',this.ydyTime[0])
					let date = new Date(this.value1[0]); //  时间格式准换
					// console.log('选择开始', this.value1[0])
					// console.log('选择结束', this.value1[1])
					let dates = new Date(this.value1[1]); //  时间格式准换
					// 时间格式化
					this.date_values = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' +
							+(date.getMonth() + 1) : date.getMonth() + 1) + '-' +
						(date.getDate() < 10 ? '0' +
							(date.getDate()) : date.getDate()) + ' ' +
						(date.getHours() < 10 ? '0' +
							(date.getHours()) : date.getHours()) + ':' + '00'
					this.date_valuessss = dates.getFullYear() + '-' +
						(dates.getMonth() + 1 < 10 ? '0' +
							(dates.getMonth() + 1) : dates.getMonth() + 1) + '-' +
						(dates.getDate() < 10 ? '0' +
							(dates.getDate()) : dates.getDate()) + ' ' +
						(dates.getHours() < 10 ? '0' +
							(dates.getHours()) : dates.getHours()) + ':' + '00'
					// console.log('选择月开始时间',this.date_values)
					// console.log('选择月结束时间',this.date_valuessss)
					let _PlanEndTime = new Date(this.date_values) // 时间比较前 格式准换    开始时间
					let _PlanStartTime = new Date(this.date_valuessss) // 时间比较前 格式准换    结束时间
					let _PlanNowTime = new Date(this.ydyTime[0]) // 时间比较前 格式准换    当前时间
					date = { // 用来判断时间是否在某个区间内
						isDuringDate: function(beginDateStr, endDateStr) {
							let curDate = new Date(),
								beginDate = new Date(beginDateStr),
								endDate = new Date(endDateStr);
							if (curDate >= beginDate && curDate <= endDate) {
								return true;
							}
							return false;
						}
					}
					if (_PlanNowTime.getTime() == _PlanEndTime.getTime() || _PlanNowTime.getTime() == _PlanStartTime.getTime()) { // 判断 当前时间是否等于开始或结束时间
						this.typeNext = true
						// console.log('当前时间等于开始或结束时间')
					} else if (date.isDuringDate(this.date_values, this.date_valuessss) == true) {
						this.typeNext = true
						// console.log('当前时间在开始结束时间段内')
					} else {
						// console.log('当前时间不等于开始时间不等于结束时间不包含区间内')
						this.typeNext = false
					}
					file.KPIselectListDay({
						list: this.newList,
						beginTime: this.date_values + ':00',
						endTime: this.date_valuessss + ':00',
						next: this.typeNext
					}).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.data_list_new = data.data
              this.showList = this.linshilist;
              // console.log(this.data_list_new);
							// this.linshiLists();
						}
					}).catch((response) => {
						console.log(response)
					})
				}
				//todo
        // if (this.showList.length == 1 && this.deviceDetailMes.type == 1 && this.eqDetail) {
        //   this.detailShow(this.showList[0]);
        // }
			},
			// 获取时间
			getTime() {
				var $this = this;
				file.selectTimee().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.value1.push(data.data.beginTime, $this.updatetime(data.data.endTime))
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			// 测试用 判断当前时间是否在某个时间段
			// compareTime(){
			//   let date = {
			//     isDuringDate: function (beginDateStr, endDateStr) {
			//       let curDate = new Date(),
			//         beginDate = new Date(beginDateStr),
			//         endDate = new Date(endDateStr);
			//       if (curDate >= beginDate && curDate <= endDate) {
			//         return true;
			//       }
			//       return false;
			//     }
			//   }
			//   console.log(date.isDuringDate('2022-01', '2022-04'));
			// },
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			show(id, type) {
				this.img = id;
				if (type == "video") {
					this.dialogVideo = true;
				} else if (type == "photo") {
					this.dialogImg = true;
				}

			},
			checkDefaultValue(value) {
				let list = JSON.parse(value);
				let text = '';
				list.forEach(function(value, index2, array) {
					if (value.check == "1") {
						text += value.name + ','
					}
				});
				return text.substring(0, text.length - 1)
			},
			checkText(type) {
				let typeText = type.toString();
				let data = this.checkList.filter(function(item) {
					return item.key == typeText;
				});
				if (data != '') {
					return data[0].val
				}
			},
			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {};
				this.search({
					pageNum: 1,
					pageSize: this.pageSize,
				});
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {
				this.tableDataInfo = info;
			},

			changeSelectMonth() {
				this.tableDataTreeEdit.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataTreeEdit.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataTreeEdit.month]
					}
				}
			},
			searchPage(param) {
				let dataParam = {
					type: this.deviceDetailMes.type,
					id: this.deviceDetailMes.id,
          sortName: this.sortName,
          sort: this.sort
				}
				let newParam = Object.assign(param, dataParam);
        // this.$set(newParam, 'code', this.deviceCode);
        // this.$set(newParam, 'sortName', this.sortName);
        // this.$set(newParam, 'sort', this.sort);f
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.searchStatus(newParam);
				$('.dashBox').animate({
					scrollTop: 0
				}, 800);
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param);
			},
			searchStatus(param) {

				file.equipmentMonitoringService(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.linshilist = data.data.list;
            console.log(this.linshilist);
						this.newList = this.linshilist;
						this.pageSize = data.data.pageSize == 0 ? data.data.size : data.data.pageSize;
						this.pageCount = data.data.total;
						this.total = data.data.total
            // this.$refs.pageModel.setCurrent(this.pageNum);
            this.searchlist()
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			//获取时间的默认值
			getDate() {
				let start = this.Fungetdate(0) // 7天前
				let end = this.Fungetdate(0) // 当前时间
				this.dateValue.push(start, end)
				// console.log('aaaa',start)
				this.Readytime = this.dateValue
				this.dyTime = this.dateValue //  当前时间
			},
			//  当前时间
			Fungetdate(num) {
				let sdd = new Date();
				sdd.setDate(sdd.getDate() + num);
				let yyyy = sdd.getFullYear();
				// let MM = sdd.getMonth() + 1;//获取当前月份的日期
				let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
				let dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
				let HH = sdd.getHours() < 10 ? '0' + sdd.getHours() : sdd.getHours()
				let mm = sdd.getMinutes() < 10 ? '0' + sdd.getMinutes() : sdd.getMinutes()
				let ss = sdd.getSeconds() < 10 ? '0' + sdd.getSeconds() : sdd.getSeconds()
				return yyyy + "-" + MM
			},
			getDates() {
				let starts = this.Fungetdates(0) // 7天前
				let ends = this.Fungetdates(0) // 当前时间
				this.dateValues.push(starts, ends)
				// console.log('aaaa',starts)
				this.ydyTime = this.dateValues //  当前时间
			},
			//  当前时间
			Fungetdates(num) {
				let sdd = new Date();
				sdd.setDate(sdd.getDate() + num);
				let yyyy = sdd.getFullYear();
				// let MM = sdd.getMonth() + 1;//获取当前月份的日期
				let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
				let dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
				let HH = sdd.getHours() < 10 ? '0' + sdd.getHours() : sdd.getHours()
				let mm = sdd.getMinutes() < 10 ? '0' + sdd.getMinutes() : sdd.getMinutes()
				let ss = sdd.getSeconds() < 10 ? '0' + sdd.getSeconds() : sdd.getSeconds()
				return yyyy + "-" + MM + '-' + dd + ' ' + HH + ':' + mm
			},
			updatetime(num) {
				let sdd = new Date(num);
				let yyyy = sdd.getFullYear();
				let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
				let dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
				let HH = (sdd.getHours() + 1) < 10 ? '0' + (sdd.getHours() + 1) : (sdd.getHours() + 1)
				// let mm = sdd.getMinutes() < 10 ? '0' + sdd.getMinutes() : sdd.getMinutes()
				// let ss = sdd.getSeconds() < 10 ? '0' + sdd.getSeconds() : sdd.getSeconds()
				return yyyy + "-" + MM + '-' + dd + ' ' + HH + ':' + '00' + '00'
			},
		},
		// destroyed() {
		// 	clearInterval(this.timer)
		// 	this.timer = null
		// },
		mounted() {
			this.$nextTick(() => {
				this.dropSize();
			})
		},
		created() {
			this.getDate() //  设置默认时间
			this.getDates()
			this.getTime() // 获取时间)
			this.search()
			// this.timer = setInterval(() => {
			// 	setTimeout(() => {
			// 		this.search()
			// 	}, 0)
			// }, 5000)
		}
	}
</script>

<style>
	.font_one {
		padding-left: 10px;
		padding-top: 10px;
		cursor: pointer;
	}

	.font_one p {
		font-size: 14px;
		font-weight: bold
	}

	.box_conent_one {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: #3FB393;
		margin-left: 30px;
		font-weight: bold
	}

	.box_conent_ones {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: #959595;
		margin-left: 30px;
		font-weight: bold
	}

	.box_all_style {
		width: 260px;
		height: 296px;
		border: 1px solid #000000;
		position: relative;
		margin-right: 20px;
		margin-bottom: 10px;
	}

	/*.box_all_style:nth-child(4n){*/
	/*  margin-right: 0;*/
	/*}*/
	.box_conent_m {
		margin-left: 10px;
	}

	.box_conent_number {
		margin-left: 27px;
	}

	.box_down {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 80px;
		background: #EFEFEF;
		display: flex;
		flex-direction: column;
		line-height: 1;
		/* border-top: #DEDEDE; */
	}

	.spotMesBoxs .el-tabs__nav-scroll {
		display: flex;
		justify-content: flex-end;
	}

	/* .el-time-spinner__wrapper {
    width: 100% !important;
  }

   .el-scrollbar:nth-of-type(2) {
    display: none;
  } */
</style>



// WEBPACK FOOTER //
// src/pages/equipmentOperation/Dashboard.vue